var map = {
	"./black/qiangcha2.png": "ZkZc",
	"./blue/qiangcha2.png": "Dan6",
	"./white/qiangcha2.png": "M8pz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ORJB";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/qiangcha2\.png$
// module id = ORJB
// module chunks = 24